import { create } from "zustand";

interface NavigationState {
  isNavigating: boolean;
  targetHref: string | null;
  startNavigation: (href: string) => void;
  endNavigation: () => void;
}

export const useNavigationStore = create<NavigationState>((set) => ({
  isNavigating: false,
  targetHref: null,
  startNavigation: (href: string) =>
    set({
      isNavigating: true,
      targetHref: href,
    }),
  endNavigation: () =>
    set({
      isNavigating: false,
      targetHref: null,
    }),
}));
